import { Subscription } from 'lib.store/src/models-to-replace/auth';

export enum SubscriptionName {
  boost_pro = 'boost_pro',
}

export enum SubscriptionStatus {
  active = 'active',
  paused = 'paused',
}

export type SubscriptionData = {
  id: number;
  slug: string;
  translate: string;
};

export type GetSubscriptionDataResponse = {
  data: SubscriptionData[];
};

export type PostSubscriptionResponse = {
  data: Subscription;
};

export type SubscriptionPlan = {
  plan: {
    id: number;
    name: string;
    translate: string;
  };
  money: {
    price: number;
    currency: string;
    credits: number;
    price_per_credit: number;
    discount_annual: number;
    price_annual: number;
  };
  options: {
    credits: number;
    price: number;
  }[];
  features: {
    [key: string]: number | string | boolean;
  };
  level: number;
};

export type GetSubscriptionPlansResponse = {
  data: SubscriptionPlan[];
};

export type PostSubscriptionRequest = {
  id: number;
  translate?: string;
  data: {
    annual: boolean;
    options: {
      credits: number;
      price: number;
    } | null;
  };
};
